// extracted by mini-css-extract-plugin
export default {"desktopContainer":"Header_desktopContainer__FSzg4","mobileContainer":"Header_mobileContainer__1lZPw"};